export const INSIGHTS_ENABLED = 'INSIGHTS_ENABLED'



// WEBPACK FOOTER //
// ./src/store/modules/feature_enabled/feature_enabled.type.js